/**
 * Checks whether the candidate is not null or undefined.
 * @returns a type predicate that is
 *  - true when the candidate is NonNullable
 *  - false when the candidate is null or undefined
 */
export function isNonNullable<T>(candidate: T): candidate is NonNullable<T> {
  return candidate !== undefined && candidate !== null;
}
